import type { MaybeRefOrGetter } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  ICountry,
} from '../types';
import {
  COUNTRIES_QUERY_KEY,
  COUNTRIES_URL,
} from '../constants';

export default function useCountriesQuery(enabled: MaybeRefOrGetter<boolean | undefined> = true): IContextQueryResult<ICountry[], Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ICountry[]>({
    queryKey: [COUNTRIES_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<ICountry[]>(
      COUNTRIES_URL,
      {
        signal,
      },
    ),
    enabled,
  });
}
